import React from 'react';
import qs from 'qs';
import { LoadingDots } from '@joinclyde/clyde-react-components';

class BigCommerceInstall extends React.Component {
  componentDidMount() {
    const query = this.props.location.search.slice(1);
    this.props._bigCommerceInstall(qs.parse(query));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.shopId !== -1) {
      this.props.history.push('/welcome');
    }
  }

  render() {
    return (
      <div className='gradient'>
        <LoadingDots dotColor='clydeBlack' dotSize='large' />
      </div>
    );
  }
}

export default BigCommerceInstall;
